module.exports = __webpack_public_path__ + "static/media/F-1-1.c3ec4d9b.webp";